export default __webpack_public_path__ + "static/media/inactive2.18bf1abd.svg";